/**
 * Application root.
 *
 * Two jobs: restore the session before anything renders, and wire the axios
 * interceptor's "session is gone" callback into Redux — otherwise a refresh
 * failure would clear the token but leave the UI believing it is still signed in.
 */
import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AppRoutes from './routes/AppRoutes.jsx';
import SessionExpiredModal from './features/auth/SessionExpiredModal.jsx';
import { loadSession, sessionLost } from './features/auth/authSlice.js';
import { setSessionLostHandler } from './api/axiosClient.js';
import { readStoredSession } from './api/tokenStore.js';

export default function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    // The interceptor lives outside React, so it needs a way back in.
    setSessionLostHandler(() => dispatch(sessionLost()));

    // Only ask /auth/me if there is a token to ask with. Without this every
    // anonymous visitor pays a 401 before the login screen renders.
    if (readStoredSession()) dispatch(loadSession());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <AppRoutes />
      <SessionExpiredModal />
    </BrowserRouter>
  );
}
